import { createContext } from 'react';
import { Configurations } from '../../models';

export type ConstructorContextState = {
  state: Configurations;
  dispatch: (action: any) => void;
};

export const constructorContext = createContext<ConstructorContextState>({
  state: {} as Configurations,
  dispatch: () => undefined,
});
